import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-switch-lang';
import MenuItemSidebarLink from './MenuItemSidebarLink';
import MenuItemSub from './MenuItemSub';

function MenuItem({
  item: {
    active, type, path, onClick, icon, children, title,
  }, t,
}) {
  return (
    <li className={active ? 'active' : ''}>
      {(type === 'sub')
        ? (
          <MenuItemSub
            onClick={onClick}
            title={t(title)}
            icon={<i className={`fa ${icon}`} />}
          />
        )
        : ''}
      {(type === 'link')
        ? (
          <MenuItemSidebarLink
            path={path}
            active={active}
            onClick={onClick}
            icon={<i className={`fa ${icon}`} />}
            title={t(title)}
            haveChildren={!!children}
          />
        )
        : ''}
    </li>
  );
}

MenuItem.defaultProps = {
  icon: 'fa-circle',
};

MenuItem.propTypes = {
  icon: PropTypes.string,
};

export default translate(MenuItem);
